export function use(options, context, next) {
  typeof next === 'function' && next()
}

export function attach(options, context) {
  
}


// WEBPACK FOOTER //
// ./src/project-types/standard.js